export default __webpack_public_path__ + "static/media/shirt11.e69ead0c.jpeg";